import React, { ReactNode } from "react";

import styled from "@emotion/styled";

import Modal from "../../../../CallForTender/components/AddressModal/Modal";

const Content = styled.div`
    padding: 1em;
`;

interface iStepEditModal {
    children: ReactNode;
    isActive: boolean;
    handleClose(): void;
}

const StepEditModal = ({
    children,
    isActive = false,
    handleClose,
}: iStepEditModal) => {
    return (
        <Modal actionRow={false} isActive={isActive} handleClose={handleClose}>
            <Content>{children}</Content>
        </Modal>
    );
};

export default StepEditModal;
